import type { SearchDomain } from '@shared/types';

export const shellDeleteRequestEventName = 'av:shell-delete-request';

export interface ShellDeleteRequestDetail {
  domain: Extract<SearchDomain, 'projects' | 'leads' | 'tasks' | 'customers' | 'resources' | 'contracts' | 'invoices' | 'payments'>;
  ids: string[];
  source: 'selection' | 'current';
}

export function dispatchShellDeleteRequest(detail: ShellDeleteRequestDetail): void {
  window.dispatchEvent(new CustomEvent<ShellDeleteRequestDetail>(shellDeleteRequestEventName, { detail }));
}

export function subscribeToShellDeleteRequests(listener: (detail: ShellDeleteRequestDetail) => void): () => void {
  const handler = (event: Event) => {
    listener((event as CustomEvent<ShellDeleteRequestDetail>).detail);
  };

  window.addEventListener(shellDeleteRequestEventName, handler as EventListener);
  return () => window.removeEventListener(shellDeleteRequestEventName, handler as EventListener);
}
